export const AGES_HOM = [
  {
    name: "<30",
    age: "age_hist_hom_under_30",
    value: 0,
  },
  {
    name: "30-35",
    age: "age_hist_hom_30_35",
    value: 0,
  },
  {
    name: "35-40",
    age: "age_hist_hom_35_40",
    value: 0,
  },
  {
    name: "40-45",
    age: "age_hist_hom_40_45",
    value: 0,
  },
  {
    name: "45-50",
    age: "age_hist_hom_45_50",
    value: 0,
  },
  {
    name: "50-55",
    age: "age_hist_hom_50_55",
    value: 0,
  },
  {
    name: "55-60",
    age: "age_hist_hom_55_60",
    value: 0,
  },
  {
    name: "60-65",
    age: "age_hist_hom_60_65",
    value: 0,
  },
  {
    name: "65-70",
    age: "age_hist_hom_65_70",
    value: 0,
  },
  {
    name: "70-75",
    age: "age_hist_hom_70_75",
    value: 0,
  },
  {
    name: "75-80",
    age: "age_hist_hom_75_80",
    value: 0,
  },
  {
    name: ">80",
    age: "age_hist_hom_over_80",
    value: 0,
  },
];

export const AGES_HET = [
  {
    name: "<30",
    age: "age_hist_het_under_30",
    value: 0,
  },
  {
    name: "30-35",
    age: "age_hist_het_30_35",
    value: 0,
  },
  {
    name: "35-40",
    age: "age_hist_het_35_40",
    value: 0,
  },
  {
    name: "40-45",
    age: "age_hist_het_40_45",
    value: 0,
  },
  {
    name: "45-50",
    age: "age_hist_het_45_50",
    value: 0,
  },
  {
    name: "50-55",
    age: "age_hist_het_50_55",
    value: 0,
  },
  {
    name: "55-60",
    age: "age_hist_het_55_60",
    value: 0,
  },
  {
    name: "60-65",
    age: "age_hist_het_60_65",
    value: 0,
  },
  {
    name: "65-70",
    age: "age_hist_het_65_70",
    value: 0,
  },
  {
    name: "70-75",
    age: "age_hist_het_70_75",
    value: 0,
  },
  {
    name: "75-80",
    age: "age_hist_het_75_80",
    value: 0,
  },
  {
    name: ">80",
    age: "age_hist_het_over_80",
    value: 0,
  },
];

export const DOC_URL = "https://macarthurlab.org/2018/10/17/gnomad-v2-1/";

export const POPULATIONS_AFFIX = [
  {
    name: "Japanese",
    affix: "jpn",
  },
  {
    name: "Korean",
    affix: "kor",
  },
  {
    name: "Other East Asian",
    affix: "oea",
  },
  {
    name: "North-western European",
    affix: "nwe",
  },
  {
    name: "Bulgarian",
    affix: "bgr",
  },
  {
    name: "Estonian",
    affix: "est",
  },
  {
    name: "Other non-Finnish European",
    affix: "onf",
  },
  {
    name: "Southern European",
    affix: "seu",
  },
  {
    name: "Swedish",
    affix: "swe",
  },
  {
    name: "Male",
    affix: "male",
  },
  {
    name: "Female",
    affix: "female",
  },
];

export const GNOMAD_TYPE_MAPPINGS = {
  exomes: {
    db: "gnomad_exomes",
    dbCoverage: "gnomad_exomes_coverage",
    title: "gnomAD Exomes",
    helpText: "gnomAD Exomes",
  },
  genomes: {
    db: "gnomad_genomes",
    dbCoverage: "gnomad_genomes_coverage",
    title: "gnomAD Genomes",
    helpText: "gnomAD Genomes",
  },
  mito: {
    db: "gnomad_mito",
    dbCoverage: "gnomad_genomes_coverage",
    title: "gnomAD Mitochondrial",
    helpText: "gnomAD Mito",
  },
};
